import React, { Fragment, useRef, useState, useEffect, useCallback } from "react";
import { useEffectOnce } from "../../../hooks/useeffectonce";
import { useSelector, useDispatch } from "react-redux";
import { 
    setProcessing, setPageValue, setSettingsFormValue, setSettingsFormSettingValue, setPanes, setFieldValue, revertToDefault, disposePage,
    loadNewReportPage, loadExistingReportPage, loadDatasetDataSources, dataSourceReset, showSettingsFormNew, showSettingsForm, closeSettingsForm, settingsFormPrevious, settingsFormNext,
    settingsFormSave, loadDataSourceMock, deleteEntity, createEntity, updateEntity, loadDataSourceFields, resetTileWidget, zoomIn, zoomOut,
    createAutoWidget, getOrCreateImplicitValueDataSource, redrawTiles,
    setContainsWidgetsNonDeepChanges, setContainsWidgetsDeepChanges, setContainsGlobalChanges,
    closeSchedulePopup
} from "../../../redux/slices/reportingdesignpageslice";
import { setPageCommands } from "../../../redux/slices/dictaphoneslice";
import { setCurrentPage, setCurrentPageIsDirty} from "../../../redux/slices/currentpageslice";
import { addNotification } from "../../../redux/slices/notificationsslice";
import { hideAppDialog, setAppDialog } from "../../../redux/slices/appdialogslice";
import { cloneReport, initEntityCloner } from "../../../redux/slices/entityclonerslice";
import { useNavigate, useLocation, useParams  } from "react-router-dom";
import { apiErrorsHandler, getErrorMessages } from "../../../api/httpclient";
import { Page } from "../../page";
import { isInteger, isEmptyObject, notificationDurationMiddle, beepFile, deepCompare } from "../../../lib/utils";
import { List } from "../../../components/list";
import { EntityCloner } from "../../../components/entitycloner";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { Loader } from "@progress/kendo-react-indicators";
import { Splitter, PanelBar, PanelBarItem, TileLayout } from "@progress/kendo-react-layout";
import { 
    widgetsInfo, isChart, isMinMaxChart, WIDGET_LINE_CHART,
    WIDGET_TICKER, WIDGET_GAUGE_CARD, WIDGET_FUNNEL_CHART, WIDGET_WATERFALL_CHART, DEFAULT_ROW_HEIGHT, WIDGET_NUMERIC_CARD, WIDGET_DATE_CARD, WIDGET_GRID
} from "../../../components/widgets/utils";
import { Checkbox } from "@progress/kendo-react-inputs";
import { SvgIcon } from "@progress/kendo-react-common";
import { saveIcon } from "@progress/kendo-svg-icons";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Input, TextArea } from "@progress/kendo-react-inputs";
import { Toolbar, ToolbarItem, ToolbarSeparator, ToolbarSpacer,Button, DropDownButton } from "@progress/kendo-react-buttons";
import { Dialog,  DialogActionsBar } from "@progress/kendo-react-dialogs";
import { WidgetSettingsForm } from "./widgetsettingsform";
import { APP_TITLE, BLOCK_DIRTY_MESSAGE } from "../../../settings";

import * as htmlToImage from 'html-to-image';
import download from "downloadjs";

import "./reportingdesignpage.css";
import { canCreateReports, canEditReports, canViewAnyReport, canViewReport, reportsMaxReached } from "../../../routing/authorizationhandlers";
import { useKendoGridTouchDragFix } from "../../../hooks/useKendoGridTouchDragFix";


import i18next from "i18next";
import { useTranslation } from "react-i18next";
// const groupsItemRenderer = (currentTheme, onGroupCheck) => (props, item, index) => {
//     return (            
//       <div key={item.Id} className={`list-item`}>
//         <div style={{width:28}}>
//             <Checkbox value={item.Checked} onChange={e => onGroupCheck(item)} />
//         </div>
//         <div className="list-item-name">{item.Name}</div>    
//     </div>             
//     );
// };

export const ReportingDesignPage = props => {
    const dispatch = useDispatch();
    const pageState = useSelector(state => state.reportingDesignPage);
    const currentTheme = useSelector(state => state.currentTheme);
    const currentUser = useSelector(state => state.currentUser);
    const navigate = useNavigate();
    const appearance = useSelector(state => state.appearance);
    const currentPageState = useSelector(state => state.currentPage);
    const {id} = useParams();
    useKendoGridTouchDragFix();
    const { t } = useTranslation();

    const pageMode = (pageState.reportId == null || pageState.reportId < 1) ? 1 : 2;
    
    const location = useLocation();

    let currentPageId = "reportingDesignPage";

    useEffect(()=>{
        let _id = id;

        if (!_id || _id.toString().trim() == "")
        {
            //not found
            navigate("/notfound", {replace: true});
            return;
        }
    
        _id = _id.toString().trim();

        //get page data
        if (_id == "new")
        {
            if (!canCreateReports(currentUser))
            {
                navigate("/unauthorized", {replace: true});
                return;
            }

            dispatch(loadNewReportPage(t)).then(
                response => {
                },
                err =>{
                    //hide loader
                    dispatch(setProcessing({processing: false}));
    
                    const handleResponseReceived = (state, dispatch, navigate, payload) =>{
                        let errorMessages = payload?.data?.ErrorMessages;
    
                        //notify with error
                        if (!errorMessages || errorMessages.length == 0)
                            dispatch(addNotification({text: t("reporting.design.loading_errormessage"), type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                        else
                        {
                            errorMessages = getErrorMessages(errorMessages, 1);
                            dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                        }
    
                        //go home
                        navigate("/", {replace: true});
                    };
    
                    const handleUnhandled = (state, dispatch, navigate, payload) =>{
                        dispatch(addNotification({text: t("reporting.design.unknown_error"), type:"error", closable: true, duration: notificationDurationMiddle, position: "topRight"}));
                        navigate("/", {replace: true});
                    };
    
                    apiErrorsHandler({}, dispatch, navigate, err, "/", {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
                }
            );       
        }  
        else
        {
            if (!canEditReports(currentUser))
            {
                navigate("/unauthorized", {replace: true});
                return;
            }
            
            dispatch(loadExistingReportPage(_id, t)).then(
                response => {
                },
                err =>{
                    //hide loader
                    dispatch(setProcessing({processing: false}));
    
                    const handleResponseReceived = (state, dispatch, navigate, payload) =>{
                        let errorMessages = payload?.data?.ErrorMessages;
    
                        //notify with error
                        if (!errorMessages || errorMessages.length == 0)
                            dispatch(addNotification({text: t("reporting.design.loading_errormessage"), type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                        else
                        {
                            errorMessages = getErrorMessages(errorMessages, 1);
                            dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                        }
    
                        //go home
                        navigate("/", {replace: true});
                    };
    
                    const handleUnhandled = (state, dispatch, navigate, payload) =>{
                        dispatch(addNotification({text: t("reporting.design.unknown_error"), type:"error", closable: true, duration: notificationDurationMiddle, position: "topRight"}));
                        navigate("/", {replace: true});
                    };
    
                    apiErrorsHandler({}, dispatch, navigate, err, "/", {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
                }
            );      
        }

        return () => {
            document.title=APP_TITLE;
            dispatch(setCurrentPage({id: "", isDirty: false}));
            dispatch(disposePage(true));
        }
    },[location.pathname]);

    useEffect(() =>{
        window.addEventListener("keydown", keyDownHandler);

        return () => window.removeEventListener("keydown", keyDownHandler);
    }, [pageState]);

    // useEffect(() => {
    //     dispatch(setPageCommands(commands));
    // });
    /*initial page load*/

    /*splitter*/
    const handleOnSplitterChange = e => {
        dispatch(setPanes(e.newState));
    };
    /*splitter*/


    /*tiles reposition*/
    const isTileResizing = useRef(false);
    const resizingTileId = useRef(0);

    const handleOnTileResizeFinished = (e) => {
        if (isTileResizing.current == true && resizingTileId)
        {
            const tileId = resizingTileId.current;
            isTileResizing.current = false;
            resizingTileId.current = 0;        

            window.removeEventListener("mouseup", handleOnTileResizeFinished);

            let widgetTypeId = pageState.tiles.find(e => e.Id == tileId).WidgetTypeId;

            if (tileId && (isChart(widgetTypeId) || widgetTypeId == WIDGET_GAUGE_CARD))
                dispatch(resetTileWidget(tileId));    
        }                    
    };

    const handleTilesReposition = e =>{
        dispatch(setPageValue({id: "tiles", value: pageState.tiles.map((item, index) => {
            return {...item, defaultPosition: {...e.value[index]}};
          }) 
        }));

        let oldArr = e.target.props.positions;
        let newArr = e.value;
        let index = -1;

        for (let i in oldArr)
        {
            if (oldArr[i].order != newArr[i].order || oldArr[i].col != newArr[i].col)
                return;
            if (oldArr[i].colSpan != newArr[i].colSpan || oldArr[i].rowSpan != newArr[i].rowSpan)
                index = i;
        }
        
        //console.log("ISRESIZE")
        //I am here => resize
        let tile = pageState.tiles.find(e => e.defaultPosition.order == newArr[index].order);
        if (!isTileResizing.current)
        {
            isTileResizing.current = true;
            resizingTileId.current = tile.Id;

            window.addEventListener("mouseup", handleOnTileResizeFinished);
            //console.log("ISRESIZE INNNN")
        }           
    };

    const paperContentRef = useRef(null);

    const handleOnPaperHeightIncrease = e => {
        paperContentRef.current.element.style.height = (paperContentRef.current.element.clientHeight + 50) + "px";       
    };

    const handleOnPaperHeightDecrease = e => {
        paperContentRef.current.element.style.height = (paperContentRef.current.element.clientHeight - 50) + "px";       
    };

    /*tiles reposition*/

    /*live report*/
    const handleOnToggleIsLiveReport = e => {
        dispatch(setPageValue({id: "isLiveReport", value: !pageState.isLiveReport}));
        handleSetContainsGlobalChanges({id:"isLiveReport", value: !pageState.isLiveReport});
    };
    /*live report*/

    /*is favorite*/
    const handleOnToggleIsFavorite = e => {
        dispatch(setPageValue({id: "isFavorite", value: !pageState.isFavorite}));
        handleSetContainsGlobalChanges({id:"isFavorite", value: !pageState.isFavorite});
    }
    /*is favorite*/

     /*new widget*/
     const handleOnNewWidget = (widgetTypeId) => {
        dispatch(showSettingsFormNew({widgetTypeId}));
     };
     /*new widget*/


     /*settings form*/
     const formValidator = (formValues) => 
    {
        //validates only when we have chart widget settings
        let formState = pageState.settingsForm;
        let values = formValues.settings;

        let formErrors = {};
        const widgetTypeId =  formState.widgetTypeId;

        if (!isChart(widgetTypeId))
            return undefined;

        const _isMinMax = isMinMaxChart(widgetTypeId);

        //i am here => validate
        let categoryFieldId = values["categoryFieldId"];
        let valueFieldId = values["valueFieldId"];
        let secondaryFieldId = values["secondaryFieldId"];
        let aggregate = values["aggregate"];
        let legendPosition = values["legendPosition"];
        let lineStyle = values["lineStyle"];
        
        if (categoryFieldId < 1)
            formErrors = Object.assign(formErrors, {"settings.categoryFieldId": t("reporting.design.field")});

        if (valueFieldId < 1)
            formErrors = Object.assign(formErrors, {"settings.valueFieldId": t("reporting.design.field1")});
        
        if (categoryFieldId > 0 && valueFieldId > 0 && categoryFieldId == valueFieldId)
            formErrors = Object.assign(formErrors, {"settings.valueFieldId": t("reporting.design.field2")});  

        if (secondaryFieldId > 0 && categoryFieldId > 0 && secondaryFieldId == categoryFieldId)
            formErrors = Object.assign(formErrors, {"settings.secondaryFieldId": t("reporting.design.field3")});

        if (secondaryFieldId > 0 && valueFieldId > 0 && secondaryFieldId == valueFieldId)
            formErrors = Object.assign(formErrors, {"settings.secondaryFieldId": t("reporting.design.field4")});

        if (!_isMinMax)
        {
            //aggregate is required
             if (!aggregate || aggregate.trim() == "")
                formErrors = Object.assign(formErrors, {"settings.aggregate": t("reporting.design.field5")});
        }
        else{
            //if either aggregate or secondary field exists => both must exist
            if ((secondaryFieldId >= 1 && (!aggregate || aggregate.trim() == "")) || (secondaryFieldId < 1 && aggregate && aggregate.trim() != ""))
                formErrors = Object.assign(formErrors, {"settings.secondaryFieldId": t("reporting.design.field6")});
        }
       
        if (widgetTypeId == WIDGET_LINE_CHART && lineStyle < 1)
            formErrors = Object.assign(formErrors, {"settings.lineStyle": t("reporting.design.field7")});

        if (isEmptyObject(formErrors))
            return undefined;
    
        return formErrors;
    }

     const handleOnSettingsFormDatasetChange = (e, formRenderProps) =>{
        const datasetId = e.value;
        
        dispatch(loadDatasetDataSources(datasetId, t)).then(
            response =>{                
                formRenderProps.onChange("dataSourceId", {value: 0});
                formRenderProps.onChange("aggregateExpressionId", {value: 0});
                dispatch(dataSourceReset());
            },
            err => {
                //hide loader
                dispatch(setProcessing({processing: false}));

                const handleResponseReceived = (state, dispatch, navigate, payload) => {
                    let errorMessages = payload?.data?.ErrorMessages;

                    if (!errorMessages || errorMessages.length == 0)
                        errorMessages = [t("reporting.design.unknown_error")];
                    else                    
                        errorMessages = getErrorMessages(errorMessages, 1);                                         

                    dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                };

                const handleUnhandled = (state, dispatch, navigate, payload) =>{
                    let errorMessage = t("reporting.design.unknown_error");
                    dispatch(addNotification({text: errorMessage, type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                };

                apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});                

                dispatch(loadDatasetDataSources(0));
                dispatch(dataSourceReset());

                formRenderProps.onChange("datasetId", {value: 0});
                formRenderProps.onChange("dataSourceId", {value: 0});
                formRenderProps.onChange("aggregateExpressionId", {value: 0});
            }
        );
     };

     const handleOnSettingsFormDataSourceChange = (e, formRenderProps) => { 
        let formState = pageState.settingsForm;

        if (!isChart(formState.widgetTypeId) && formState.widgetTypeId != WIDGET_TICKER)
        {
            dispatch(setSettingsFormValue({id: "dataSourceId", value: e.value}));

            dispatch(setSettingsFormValue({id: "aggregateExpressionId", value: 0}));
            formRenderProps.onChange("aggregateExpressionId", {value: 0});

            dispatch(dataSourceReset());
            return;
        }

        //chart || ticker => must load data source fields - the loadDataSourceFields() that we'll call will check if the
        //data source is already in mock and in this case no DB call is made       
        dispatch(loadDataSourceFields(e.value, t)).then(
            data => {
                
            },
            err =>{
                //hide loader
                dispatch(setProcessing({processing: false}));

                const handleResponseReceived = (state, dispatch, navigate, payload) =>{
                    let errorMessages = payload?.data?.ErrorMessages;

                    //notify with error
                    if (!errorMessages || errorMessages.length == 0)
                        dispatch(addNotification({text: t("reporting.design.loading_errormessage"), type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                    else
                    {
                        errorMessages = getErrorMessages(errorMessages, 1);
                        dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                    }
                };

                const handleUnhandled = (state, dispatch, navigate, payload) =>{
                    dispatch(addNotification({text: t("reporting.design.unknown_error"), type:"error", closable: true, duration: notificationDurationMiddle, position: "topRight"}));
                };

                apiErrorsHandler({}, dispatch, navigate, err, "/", {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
            }
        );
     };

     const handleOnSettingsFormAggregateExpressionChange = (e, formRenderProps) => {
        let formState = pageState.settingsForm;
        
        dispatch(setSettingsFormValue({id: "dataSourceId", value: 0}));
        formRenderProps.onChange("aggregateExpressionId", {value: e.value});

        dispatch(setSettingsFormValue({id: "aggregateExpressionId", value: e.value}));                   

        dispatch(dataSourceReset());
     };

     const handleOnSettingsFormPrevious = e => {
        dispatch(settingsFormPrevious());
     };

     const handleOnSettingsFormNext = (e, formRenderProps) => {
        let formState = pageState.settingsForm;

        if (formState.mode == 1 && formState.dataSourceTypeId == 1 && !formState.formValues.settings.title)
        {
            const dataSourceId = formState.formValues.dataSourceId;
            const aggregateExpressionId = formState.formValues.aggregateExpressionId;
            let title = "";

            if (dataSourceId > 0)
                title = formState.dataSources.find(e => e.Id == dataSourceId).Title;
            else if (aggregateExpressionId > 0)
                title = formState.aggregateExpressions.find(e => e.Id == aggregateExpressionId).Title;
            
            if (title)
                {
                    dispatch(setSettingsFormSettingValue({id:"title", value: title, setInInitial: true}));
                    formRenderProps.onChange("settings.title", {value: title});
                }
        }

        dispatch(settingsFormNext());

     };

     const handleOnSettingsFormFieldValueChange = obj =>{
        dispatch(setSettingsFormSettingValue({id: obj.id, value: obj.value}));
     };

     const handleOnSettingsFormSave = () => {
        const dataSourceId = pageState.settingsForm.formValues.dataSourceId;
        const aggregateExpressionId = pageState.settingsForm.formValues.aggregateExpressionId;

        //validation
        const isValidForm = formValidator(pageState.settingsForm.formValues) == undefined;
        if (!isValidForm)
        {
            dispatch(addNotification({text: t("reporting.design.invaliddata"), type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
            return;
        }

        if (dataSourceId > 0)
        {
            //user is binding to a data source not agg. exp.
            //if data source is in mocks => proceed
            if (pageState.mocks.find(e => e.DataSourceId == dataSourceId))
            {
                dispatch(settingsFormSave());
                return;
            }

            //if data source is not in mock => need to load them
            dispatch(loadDataSourceMock(dataSourceId, t)).then(
                data => {
                },
                err =>{
                    //hide loader
                    dispatch(setProcessing({processing: false}));

                    const handleResponseReceived = (state, dispatch, navigate, payload) =>{
                        let errorMessages = payload?.data?.ErrorMessages;

                        //notify with error
                        if (!errorMessages || errorMessages.length == 0)
                            dispatch(addNotification({text: t("reporting.design.loading_errormessage"), type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                        else
                        {
                            errorMessages = getErrorMessages(errorMessages, 1);
                            dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                        }
                    };

                    const handleUnhandled = (state, dispatch, navigate, payload) =>{
                        dispatch(addNotification({text: t("reporting.design.unknown_error"), type:"error", closable: true, duration: notificationDurationMiddle, position: "topRight"}));
                    };

                    apiErrorsHandler({}, dispatch, navigate, err, "/", {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
                }
            );
        }
        else{
            //binding to agg. exp not data source => for sure we have value not table widget
            const dataSourceValueType = pageState.settingsForm.dataSourceValueTypeId;

            //if there exists an implicit data source that is already loaded and matching our agg. exp => proceed to settingsFormSave - else get or create implicit data source
            if (dataSourceValueType == 4 || dataSourceValueType == 5)   
            {
                //data agg. exp.
                if (pageState.mocks.find(e => e.DataSourceIsImplicit==true && e.DataSourceTypeId == 1 && (e.DataSourceValueTypeId == 4 || e.DataSourceValueType == 5) && e.Schema[0].FieldId == aggregateExpressionId && e.Schema[0].FunctionId <= 0))
                {
                    dispatch(settingsFormSave());
                    return;
                }
            }
            else
            {
                if (pageState.mocks.find(e => e.DataSourceIsImplicit==true && e.DataSourceTypeId == 1 && e.DataSourceValueTypeId == dataSourceValueType && e.Schema[0].FieldId == aggregateExpressionId && e.Schema[0].FunctionId <= 0))
                {
                    dispatch(settingsFormSave());
                    return;
                }
            }            

            dispatch(getOrCreateImplicitValueDataSource(aggregateExpressionId, t)).then(
                data => {
                },
                err =>{
                    //hide loader
                    dispatch(setProcessing({processing: false}));

                    const handleResponseReceived = (state, dispatch, navigate, payload) =>{
                        let errorMessages = payload?.data?.ErrorMessages;

                        //notify with error
                        if (!errorMessages || errorMessages.length == 0)
                            dispatch(addNotification({text: t("reporting.design.loading_errormessage"), type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                        else
                        {
                            errorMessages = getErrorMessages(errorMessages, 1);
                            dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                        }
                    };

                    const handleUnhandled = (state, dispatch, navigate, payload) =>{
                        dispatch(addNotification({text: t("reporting.design.unknown_error"), type:"error", closable: true, duration: notificationDurationMiddle, position: "topRight"}));
                    };

                    apiErrorsHandler({}, dispatch, navigate, err, "/", {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
                }
            );
        }
     };

     const handleOnCloseSettingsForm = e => {
        dispatch(closeSettingsForm());
     };
     /*settings form*/

     /*auto widget*/
     const handleOnAutoNewWidget = async (widgetTypeId, dataSourceName) =>{
        dispatch(createAutoWidget(widgetTypeId, dataSourceName, t)).then(
        response =>{
            dispatch(setProcessing({processing: false}));
        },
        err =>
        {

                //hide loader
                dispatch(setProcessing({processing: false}));

                if (typeof(err) == "string")
                {
                    dispatch(addNotification({text: err, type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                    return;
                }
    
                const handleResponseReceived = (state, dispatch, navigate, payload) =>{
                    let errorMessages = payload?.data?.ErrorMessages;

                    //notify with error
                    if (!errorMessages || errorMessages.length == 0)
                        dispatch(addNotification({text: t("reporting.design.complete_errormessage"), type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                    else
                    {
                        errorMessages = getErrorMessages(errorMessages, 1);
                        dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                    }
                };

                const handleUnhandled = (state, dispatch, navigate, payload) =>{
                    dispatch(addNotification({text: t("reporting.design.unknown_error"), type:"error", closable: true, duration: notificationDurationMiddle, position: "topRight"}));
                };

                apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
        }
    );
    };
     /*new widget*/

    /*delete entity*/   
    const handleOnDelete = () => {        
        const referenceKey = pageState.referenceKey;

        dispatch(setAppDialog({
            isVisible: true,
            className: "reporting-design-page-are-you-sure",
            title: t("reporting.design.warning"), content: t("reporting.design.areyousure"),
            actions:{
                yesButton:{ title: t("reporting.design.yes"), handler: () =>{
                    dispatch(hideAppDialog());

                    //id is the useParam declared at top of the component
                    dispatch(deleteEntity(id, t))
                    .then(
                        response =>{
                            navigate("/", {replace: true});
                        },
                        err => {
                            dispatch(setProcessing({processing: false}));

                            const handleResponseReceived = (state, dispatch, navigate, payload) => {
                                let errorMessages = payload?.data?.ErrorMessages;
            
                                if (!errorMessages || errorMessages.length == 0)
                                    errorMessages = [t("reporting.design.unknown_error")];
                                else
                                {
                                    errorMessages = getErrorMessages(errorMessages, 1);                   
                                }
            
                                dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                            };
            
                            const handleUnhandled = (state, dispatch, navigate, payload) =>{
                                let errorMessage = t("reporting.design.unknown_error");
                                dispatch(addNotification({text: errorMessage, type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                            };
            
                            apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});                
                        });
                }},
                noButton: {title: t("reporting.design.no")}
            }
        }));
    };
    /*delete entity*/

    /*create entity*/
    const handleOnSaveReport = () =>{
        //take a snapshot and pass it to action
        // let thumbnail = null;
        // try{
        //     thumbnail =  await getSnapshot();
        // }
        // catch(err)
        // {
        //     console.log(err)
        //     dispatch(addNotification({text: "Failed to take report snapshot!", type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
        //     return;            
        // }


        //report title must be specified
        if (!pageState.reportTitle || pageState.reportTitle.trim() == "")
        {
            dispatch(addNotification({text: t("reporting.design.reporterror") , type:"error", closable: true, duration: notificationDurationMiddle, position: "topRight"}));
            return;
        }
        else if (pageState.reportTitle.trim().indexOf("©") >= 0)
        {
            dispatch(addNotification({text: t("reporting.design.reporterror1"), type:"error", closable: true, duration: notificationDurationMiddle, position: "topRight"}));
            return;
        }
        
        if (pageState.reportId == null || pageState.reportId == 0)   
            //create report => call action
            dispatch(createEntity(t)).then(
                response =>{
                    let referenceKey = response.referenceKey;

                    dispatch(setProcessing({processing: false}));

                    dispatch(addNotification({text: t("reporting.design.reportsuccess"), type: "success", closable: true, duration: notificationDurationMiddle, position:"topRight"}));

                    if (pageState.canEdit)
                        navigate("/reportingdesign/" + referenceKey);
                    else
                        navigate("/reports");
                },
                err =>
                {
                    //hide loader
                    dispatch(setProcessing({processing: false}));
            
                    const handleResponseReceived = (state, dispatch, navigate, payload) =>{
                        let errorMessages = payload?.data?.ErrorMessages;
    
                        //notify with error
                        if (!errorMessages || errorMessages.length == 0)
                            dispatch(addNotification({text: t("reporting.design.save_errormessage"), type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                        else
                        {
                            errorMessages = getErrorMessages(errorMessages, 1);
                            dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                        }
                    };
    
                    const handleUnhandled = (state, dispatch, navigate, payload) =>{
                        dispatch(addNotification({text: t("reporting.design.unknown_error"), type:"error", closable: true, duration: notificationDurationMiddle, position: "topRight"}));
                    };
    
                    apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
                }
            );
        else
            dispatch(updateEntity(false, t)).then(
                response =>{
                    //reload page to avoid concurrency error if add a new widget after saving the report
                    //you cann uncomment the below to view this effect; add a widget and then save => report is updated;
                    //then add a widget and save => you'll get the concurrency error
                    //window.location.reload();
                },
                err =>
                {
                    //hide loader
                    dispatch(setProcessing({processing: false}));
            
                    const handleResponseReceived = (state, dispatch, navigate, payload) =>{
                        let errorMessages = payload?.data?.ErrorMessages;
    
                        //notify with error
                        if (!errorMessages || errorMessages.length == 0)
                            dispatch(addNotification({text: t("reporting.design.save_errormessage"), type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                        else
                        {
                            errorMessages = getErrorMessages(errorMessages, 1);
                            dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                        }
                    };
    
                    const handleUnhandled = (state, dispatch, navigate, payload) =>{
                        dispatch(addNotification({text: t("reporting.design.unknown_error"), type:"error", closable: true, duration: notificationDurationMiddle, position: "topRight"}));
                    };
    
                    apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
                }
            );
    };
    /*create entity*/

    /*revert to default*/
    const handleOnRevertToDefault = (e) => {
        dispatch(setAppDialog({
            isVisible: true,
            className: "reporting-design-page-are-you-sure",
            title: t("reporting.design.warning"), content: t("reporting.design.areyousure1"),
            actions:{
                yesButton:{ title: t("reporting.design.yes"), handler: () =>{
                    dispatch(hideAppDialog());

                    dispatch(revertToDefault(t))
                    .then(
                        response =>{
                            //navigate("/reportingdesign/" + pageState.reportReferenceKey, {replace: true});
                            window.location.href = "/reportingdesign/" + pageState.reportReferenceKey;
                        },
                        err => {
                            dispatch(setProcessing({processing: false}));

                            const handleResponseReceived = (state, dispatch, navigate, payload) => {
                                let errorMessages = payload?.data?.ErrorMessages;

                                if (!errorMessages || errorMessages.length == 0)
                                    errorMessages = [t("reporting.design.unknown_error")];
                                else
                                {
                                    errorMessages = getErrorMessages(errorMessages, 1);                   
                                }

                                dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                            };

                            const handleUnhandled = (state, dispatch, navigate, payload) =>{
                                let errorMessage = t("reporting.design.unknown_error");
                                dispatch(addNotification({text: errorMessage, type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                            };

                            apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});                
                        });
                }},
                noButton: {title: t("reporting.design.no")}
            }
        }));        
    };
    /*revert to default*/


    /*save as default*/
    const handleOnSaveReportAsDefault = (e) => {
        dispatch(setAppDialog({
            isVisible: true,
            className: "reporting-design-page-are-you-sure",
            title: t("reporting.design.warning"), content: t("reporting.design.areyousure2"),
            actions:{
                yesButton:{ title: t("reporting.design.yes"), handler: () =>{
                    dispatch(hideAppDialog());

                    dispatch(updateEntity(true, t)).then(
                        response =>{
                        },
                        err =>
                        {
                            //hide loader
                            dispatch(setProcessing({processing: false}));
                    
                            const handleResponseReceived = (state, dispatch, navigate, payload) =>{
                                let errorMessages = payload?.data?.ErrorMessages;
            
                                //notify with error
                                if (!errorMessages || errorMessages.length == 0)
                                    dispatch(addNotification({text: t("reporting.design.save_errormessage"), type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                                else
                                {
                                    errorMessages = getErrorMessages(errorMessages, 1);
                                    dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                                }
                            };
            
                            const handleUnhandled = (state, dispatch, navigate, payload) =>{
                                dispatch(addNotification({text: t("reporting.design.unknown_error"), type:"error", closable: true, duration: notificationDurationMiddle, position: "topRight"}));
                            };
            
                            apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
                        }
                    );               
                }},
                noButton: {title: t("reporting.design.no")}
            }
        }));        
    };
    /*save as default*/

    //zooming
    const zoomTransformOrigin = pageState.zoom >= 1 ? "top left" : "center 0%";

    //tools visible/hidden
    const toolsVisibleIcon = pageState.toolsVisible ? "unpin" : "pin";
    const toolsVisibleTitle = pageState.toolsVisible ? t("reporting.design.hide"): t("reporting.design.show");
    const handleOnToolsToggle = e => {
        const isVisible = pageState.toolsVisible;

        if(isVisible)//hide
            dispatch(setPanes([
                {
                    //size: "30%",
                    size:"0%",
                    min: "%",
                    max: "%",
                    collapsible: false
                },           
                {
                    min: "100%",
                    collapsible: false,
                }, 
            ]));
        else
            dispatch(setPanes([
                {
                    //size: "30%",
                    size:"20%",
                    min: "20%",
                    max: "20%",
                    collapsible: false
                },           
                {
                    min: "80%",
                    collapsible: false,
                },
            ]));

        dispatch(setPageValue({id: "toolsVisible", value: !isVisible}));
        dispatch(redrawTiles());
    };


    //view-design switching
    
    const handleOnGotoViewMode = () => {
        if (!currentUser.IsAuthenticated || (!canViewReport(currentUser) && !canViewAnyReport(currentUser)))
            return;

        if (blockNavigationIfDirty())
           return;

        navigate("/reportingview/" + pageState.reportReferenceKey);
     };

     const handleOnGotoDesignMode = () => {
        if (!currentUser.IsAuthenticated || (!canEditReports(currentUser)))
            return;

        if (blockNavigationIfDirty())
           return;

        navigate("/reportingdesign/" + pageState.reportReferenceKey);
     };

     //reorder ticker fields
     /*D&D*/
    const handleOnTickerFieldsReorder = (e, data, formRenderProps) =>{
        if (!data)
           return;

        let sourceItem = data.sourceItem;
        let targetItemId = data.targetItemId;

        if (sourceItem.id == targetItemId)
            return;

        let sourceIndex = pageState.settingsForm.formValues.settings.fields.findIndex(e => e.id == sourceItem.id);
        let targetIndex = pageState.settingsForm.formValues.settings.fields.findIndex(e => e.id == targetItemId);
        
        let newFields = [...pageState.settingsForm.formValues.settings.fields];
        let item = newFields[sourceIndex];

        //remove then insert then reorder
        newFields.splice(sourceIndex, 1);
        newFields.splice(targetIndex, 0, {...item});
        newFields = newFields.map((item, index) => ({...item, orderId: index}));

        dispatch(setSettingsFormSettingValue({id: "fields", value: newFields}));
        //formRenderProps.onChange("fields", {value: newFields});
    };

     //snapshot
     const contentZoneRef = useRef(null);

     const getSnapshot = async (e) => {
        let w = parseInt(contentZoneRef.current.innerWidth);
        let h = parseInt(contentZoneRef.current.innerHeight);//parseInt(w * 0.75);

        let dataUrl =  null;
        
        try
        {
            dataUrl = await htmlToImage.toJpeg(contentZoneRef.current, {
                width: w, height: h, 
                quality: 0.9, //skipAutoScale: true,
                //backgroundColor: "#002240"
            });

            return dataUrl;            
        }
        catch(ex)
        {
            return null;
        }       
     };

     const handleOnSnapshot = async e => {
        let dataUrl = await getSnapshot();
        if (dataUrl)
            download(dataUrl, 'vas-report.jpg');
     }

     /*check/uncheck security group*/
    const handleOnGroupsCheck = (item) => {
        let items = item.value;
        
        let groups = pageState.groups.map(e => {
            if (items && items.length > 0 && items.find(i => i.Id == e.Id))
                return {...e, Checked: true};
            else
                return {...e, Checked: false};
        });

        let groupsIds = groups.filter(e => e.Checked == true).map(e => e.Id);

        dispatch(setPageValue({id: "groups", value: groups}));
        dispatch(setPageValue({id: "groupsIds", value: groupsIds}));

        handleSetContainsGlobalChanges({id:"groupsIds", value: groupsIds});
    };


    //keyboards shortcuts
    const keys = [38, 40, 187, 189, 70, 79, 67, 86, 76, 83];

    const keyDownHandler = (e) => {
        e = e || window.event; 
        let key = e.which || e.keyCode;
        //console.log(key)

        var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

        if (ctrl && keys.find(e => e == key))
        {        
            e.preventDefault();
            e.stopPropagation();
            // if (key == 83)//s         
            //     handleOnSaveReport();
            // else 
            if (key == 76)//l
                handleOnToggleIsLiveReport();
            // else if (key == 70)//f
            //     handleOnToggleIsFavorite();
            // else if (key == 79)//o
            //     handleOnToolsToggle();
            // else if (key == 67)//c
            //     handleOnSnapshot();
            // else if (key == 68)//d
            //     handleOnGotoDesignMode();
            else if (key == 86)//v
                handleOnGotoViewMode();
            else if (key == 187)//+
                dispatch(zoomIn());
            else if (key == 189)//-
                dispatch(zoomOut());
            else if (key == 40)//Down
                handleOnPaperHeightIncrease();
            else if (key == 38)//Up
                handleOnPaperHeightDecrease();
        

            return false;          
        }
    };

    const boxShadow = currentTheme.darkTheme ? "2px 2px " + currentTheme.componentBorderColor : "none";

    //shchema menu renderer
    const schemaMenuRenderer = (props) => {
        let{id, text, tooltip, icon, itemIndex, ...other} = props.item;
        return (
            <div title={tooltip} className={`reporting-design-schema-menu-${id}`} style={{padding: "2px 6px", display: "flex", justifyContent: "space-between"}}>
                <span className={`k-icon k-font-icon k-i-${icon}`} style={{paddingTop:6}}></span>
                <div style={{marginLeft:8}}>{text}</div>
            </div>
        );
      };


    //handle isDirty
    const isDirty = pageState.containsWidgetsNonDeepChanges || pageState.containsWidgetsDeepChanges || pageState.containsGlobalChanges;

    const blockNavigationIfDirty = (msg) => {
        //console.log(">>> ", pageState.containsWidgetsNonDeepChanges, pageState.containsWidgetsDeepChanges, pageState.containsGlobalChanges)
        if (isDirty)//was currentPageState.isDirty
        {
            if (window.confirm(msg ? msg : BLOCK_DIRTY_MESSAGE) == true)
                {
                    dispatch(setCurrentPageIsDirty(false));
                    return false;
                }
            else
                return true;
        }
        else
            return false;
    };


    //widgets deep changes
    useEffect(() =>{
        let containsWidgetsDeepChanges = pageState.containsWidgetsDeepChanges;

        //update containsWidgetsDeepChanges if contains an entry with Id < 1
        if (pageState.tiles.find(e => e.Id < 1))        
        {
            if (!containsWidgetsDeepChanges)
                {
                    dispatch(setContainsWidgetsDeepChanges(true));

                    if (!currentPageState.isDirty)
                        dispatch(setCurrentPageIsDirty(true));
                }

            return;
        }

        //check if any entry with id > 0 exists in dbTiles but not in titles => removed
        let dbIds = pageState.dbTiles.map(e => e.Id);

        if (dbIds?.length > 0)
        {
            for (let i in dbIds)
            {
                let id = dbIds[i];
                if (!pageState.tiles.find(e => e.Id == id))
                {
                    if (!containsWidgetsDeepChanges)
                        {
                            dispatch(setContainsWidgetsDeepChanges(true));

                            if (!currentPageState.isDirty)
                                dispatch(setCurrentPageIsDirty(true));
                        }

                    return;
                }
            }
        }

        if (containsWidgetsDeepChanges == true)
            {
                dispatch(setContainsWidgetsDeepChanges(false));        
                dispatch(setCurrentPageIsDirty(pageState.containsWidgetsNonDeepChanges || pageState.containsGlobalChanges || false));
            }
    }, [pageState.tiles])


    //widgets non-deep changes
    useEffect(() =>{
        let containsWidgetsNonDeepChanges = pageState.containsWidgetsNonDeepChanges;

        //go through every tile in pageState.tiles & having Id > 0
        if (pageState.tiles && pageState.tiles.length > 0)
        {
            let tiles = pageState.tiles.filter(e => e.Id > 0);
            if (tiles && tiles.length > 0)
            {
                for (let t in tiles)
                {
                    let tile = tiles[t];
                    let dbTile = pageState.dbTiles.find(e => e.Id == tile.Id);
                    if (dbTile)
                    {
                        let {item, ..._t} = tile;

                        let {dataSourceTitle, data, schema, currentPageIndex, getContextMenu, onColumnReorder, onColumnResize, onColumnSettingChange, onDoubleClick, onGroupChange,
                            onMenuItemClick, onPageChange, onSort, onWidgetSelect, onWidgetUnSelect, ...tileProperties} = tile.properties;

                        _t.properties = tileProperties;

                        if (_t.properties.fields)
                        {
                            _t.properties.fields = [..._t.properties.fields];
                            
                            _t.properties.fields.sort((v1, v2) => {
                            if (v1.orderId < v2.orderId)
                                return -1;
                            else if (v1.orderId > v2.orderId)
                                return 1;
                            else
                                return 0;
                            });
                        }

                        if (!deepCompare(dbTile.Tile, _t))
                        {
                            dispatch(setContainsWidgetsNonDeepChanges(true));

                            if(!currentPageState.isDirty)
                               dispatch(setCurrentPageIsDirty(true));

                            return;
                        }
                    }
                }
            }
        }

        if (containsWidgetsNonDeepChanges == true)
        {
            dispatch(setContainsWidgetsNonDeepChanges(false));
            dispatch(setCurrentPageIsDirty(pageState.containsWidgetsDeepChanges || pageState.containsGlobalChanges || false));
        }
    }, [pageState.tiles])


    //global changes
    const handleSetContainsGlobalChanges = ({id, value}) =>{        
        let obj = {...pageState.dbGlobalValues};
        obj[id]=value;

        let dbObj = pageState.dbGlobalValues;
        let containsGlobalChanges = pageState.containsGlobalChanges;

        let result = deepCompare(obj, dbObj);

        if (result == true)
        {
            if (containsGlobalChanges)
            {
                dispatch(setContainsGlobalChanges(false));                
                dispatch(setCurrentPageIsDirty(pageState.containsWidgetsDeepChanges || pageState.containsWidgetsNonDeepChanges || false));
            }
        }
        else
        {
            if (!containsGlobalChanges)
            {
                dispatch(setContainsGlobalChanges(true));

                if (!currentPageState.isDirty)
                    dispatch(setCurrentPageIsDirty(true));
            }
        }
    };

    let saveButtonTitle = "";
    let saveButtonTooltip  = "";
    
    if (pageMode == 1)
    {
        //create report => will create in default repo
        saveButtonTitle = t("reporting.design.savetitle");
        saveButtonTooltip = t("reporting.design.savetooltip");
    }
    else
    {
        if (pageState.containsWidgetsDeepChanges)
        {
            saveButtonTitle = t("reporting.design.savetitle1");
            saveButtonTooltip = t("reporting.design.savetooltip1");
        }
        else
        {
            saveButtonTitle = pageState.isPersonalized ? t("reporting.design.savetitle2") : t("reporting.design.savetitle3");
            saveButtonTooltip = pageState.isPersonalized ? t("reporting.design.savetooltip2") : t("reporting.design.savetooltip3");
        }
    }

    //let isPersonalizedMessage =pageState.isPersonalized ? "This is your personalized version of the report" : "This is the default version of the report";
    let isPersonalizedMessage = pageState.isPersonalized ? t("reporting.design.version") : t("reporting.design.version1");
    if (currentPageState.isDirty)
       isPersonalizedMessage += "*";

    let designItems = [];
    if (pageState.isPersonalized)
        designItems=[
            {
                id: 1,
                text: t("reporting.design.designtext"),
                tooltip: t("reporting.design.designtooltip"),
                icon: "anchor"
            },
            {
                id: 2,
                text: t("reporting.design.designtext1"),
                tooltip: t("reporting.design.designtooltip1"),
                icon: "save"
            }
        ];
    else
        designItems=[
            {
                id: 2,
                text: t("reporting.design.designtext1"),
                tooltip: t("reporting.design.designtooltip"),
                icon: "save"
            }
        ];


    //cloning
    const handleOnClone = (e) =>{
        dispatch(initEntityCloner({title: pageState.reportTitle, navigate: true}));

        dispatch(setAppDialog({
            isVisible: true, closable: true, title: t("reporting.design.clonerep"), className: "",
            content: <EntityCloner showNavigate={true} className=""/>,
            actions: {
              yesButton: {
                title: t("reporting.design.clone"), handler: e => {
                    dispatch(cloneReport(t)).then(
                        response => {
                            dispatch(hideAppDialog());

                            dispatch(addNotification({text: t("reporting.design.reportsuccess1"), type: "success", closable: true, duration:notificationDurationMiddle, position:"topRight"}));

                            if (response.navigate)
                            {
                                window.location.href="/reportingdesign/" + response.referenceKey;
                                return;
                            }
                        },
                        err => {
                            if (err == "invalidData")
                            {
                                //show notification that title is required
                                dispatch(addNotification({text: t("reporting.design.clone1"), type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                                return;
                            }
                            else if (err == "ignore")
                            {
                                //in this case the user clicked clone while it's cloning
                                //just do nothing
                                return;
                            }
                            else
                            {
                                const handleResponseReceived = (state, dispatch, navigate, payload) => {
                                    let errorMessages = payload?.data?.ErrorMessages;
                                    let errorMessage = t("reporting.design.unknown_error");

                                    if (errorMessages || errorMessages.length > 0)
                                    {
                                        errorMessages = getErrorMessages(errorMessages, 1);
                
                                        //if the error is entity does not exist => it has been removed => remove it from currentDataset and from editing
                                        if (payload.data.ErrorCodes.TitleExists)
                                            errorMessage = errorMessages[0];
                                    }

                                    dispatch(addNotification({text: errorMessage, type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                                };
                
                                const handleUnhandled = (state, dispatch, navigate, payload) =>{

                                    dispatch(addNotification({text: t("reporting.design.unknown_error"), type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                                };                            
                
                                apiErrorsHandler({}, dispatch, null, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});    

                                return Promise.resolve();
                            }
                        }
                    )
                }
              },
              noButton: {
                title: t("reporting.design.cancel")
              }
            }
          }));
    };

    //schedule
    const handleOnSchedule = () => {
        navigate("/createschedule?rptid=" + pageState.reportReferenceKey);
    };

    const handleOnWidgetSchedule = (id) => { 
        navigate("/createschedule?rptid=" + pageState.reportReferenceKey + "&widgetid=" + id);
    };

    return (
        <Fragment>
            <Page id="reportingDesignPage" className="reporting-design-page" title={t("reporting.design.reporting")}>
                <Fragment>
                {
                    pageState.processing && 
                    <div className="page-loader">
                    <Loader size={"large"} type="infinite-spinner" themeColor={"primary"} />
                    {
                        pageState.processingText && 
                        <div style={{fontSize: 13, color: currentTheme.primary}}>{pageState.processingText}</div>
                    }
                    </div>
                }
                {
                    pageState.pageLoaded && 
                    <Splitter style={{border: "none", flexDirection: appearance.isRightToLeft ? "row-reverse" : "row"}} panes={pageState.panes} onChange={handleOnSplitterChange}>                   
                        <div className="reporting-design-page-manager">
                            <PanelBar style={{border: "none"}} expanded={pageState.reportId ? [".0", ".1"] : [".0", ".1", ".2"]}>
                                {
                                !pageState.isSystem && 
                                <PanelBarItem className="panel-tools" key="tools" title={t("reporting.design.tools")} selected={false} expanded={false} >                                
                                    <div className="content">
                                        {
                                            widgetsInfo.map(item => {
                                                return (
                                                    <div key={item.id} className="widget-icon">
                                                        <div className="widget-icon-contour">
                                                            <Tooltip anchorElement="target" position="top" tooltipStyle={{fontSize:12}}>
                                                                {
                                                                    item.id != WIDGET_GAUGE_CARD &&  item.id != WIDGET_FUNNEL_CHART &&  item.id != WIDGET_WATERFALL_CHART && 
                                                                    <SvgIcon icon={item.icon} title={item.title} color={currentTheme.primary} 
                                                                        onDoubleClick={e => handleOnNewWidget(item.id)} />
                                                                }
                                                                {
                                                                    (item.id == WIDGET_GAUGE_CARD || item.id == WIDGET_FUNNEL_CHART || item.id == WIDGET_WATERFALL_CHART) &&  
                                                                    <item.icon className="external-gauge-icon" style={{height:22, width: 22, padding: item.id == WIDGET_GAUGE_CARD ? 0 : 2 }} title={item.title} //height={24} width={24} 
                                                                        onDoubleClick={e => handleOnNewWidget(item.id)}/>
                                                                }                                                                
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>                                                      
                                </PanelBarItem>
                                }
                                <PanelBarItem className="panel-report" key="report" title={`${pageState.isSystem ? t("reporting.design.system") : t("reporting.design.report")} - ${isPersonalizedMessage}`} selected={false} expanded={false} >
                                    <div className="content">
                                        <div className="panel-report-row">
                                            <div style={{color: currentTheme.inputLabelColor}}>{t("reporting.design.title")}</div>
                                            <div style={{flex:1}}><Input disabled={pageState.isSystem} maxLength={255} value={pageState.reportTitle} onChange={e => 
                                                {
                                                    dispatch(setPageValue({id: "reportTitle", value: e.target.value}));
                                                    handleSetContainsGlobalChanges({id:"reportTitle", value: e.target.value});
                                            }} /></div>
                                        </div>
                                        {/* <div className="panel-report-row" style={{marginTop: 10}}>
                                            <div style={{color: currentTheme.inputLabelColor}}>Tags</div>
                                            <div style={{flex:1}}>
                                                <TextArea maxLength={100} style={{height: 32}} value={pageState.reportTags}  onChange={e => dispatch(setPageValue({id: "reportTags", value: e.value}))}/>
                                            </div>
                                        </div> */}
                                        <div className="panel-report-row" style={{marginTop: 12}}>
                                            <div style={{color: currentTheme.inputLabelColor}}>{t("reporting.design.description")}</div>
                                            <div style={{flex:1}}><TextArea disabled={pageState.isSystem} maxLength={255} style={{height: 50}} value={pageState.reportDescription} 
                                                 onChange={e => {
                                                    dispatch(setPageValue({id: "reportDescription", value: e.value}));
                                                    handleSetContainsGlobalChanges({id:"reportDescription", value: e.value});
                                                 }}/></div>
                                        </div>
                                        <div className="panel-report-row"style={{marginTop: 12}}>
                                            <div style={{flex:1}}>
                                                <Checkbox  disabled={pageState.isSystem} checked={pageState.generateOnLoad} label={t("reporting.design.generate")} onChange={e => {
                                                    dispatch(setPageValue({id: "generateOnLoad", value: e.target.value}));
                                                    handleSetContainsGlobalChanges({id: "generateOnLoad", value: e.target.value});
                                                    }}/>
                                            </div>
                                        </div>
                                    </div>
                                </PanelBarItem>
                                {
                                    !pageState.isSystem &&
                                    <PanelBarItem className="panel-groups" key="groups" title={t("reporting.design.viewed")} selected={true} expanded={true} >
                                        <div className="content">
                                            <MultiSelect
                                                data={pageState.groups} dataItemKey="Id" textField="Name"
                                                value={pageState.groups.filter(e => e.Checked == true)}
                                                onChange={handleOnGroupsCheck}
                                                style={{
                                                    width: "100%", marginTop: 0, backgroundColor: "transparent", padding: 4
                                                }}
                                                // placeholder="Please select the groups who can view the report"
                                            />       
                                        </div>
                                    </PanelBarItem>
                                }   
                            </PanelBar>                    
                        </div>
                        <div className="reporting-design-page-content">
                            <div className="toolbar">
                                <Toolbar>
                                    <Fragment>
                                        <ToolbarItem>
                                            <Button disabled={pageState.processing} style={{color: currentTheme.primary}}   icon={toolsVisibleIcon} onClick={handleOnToolsToggle}>
                                                {toolsVisibleTitle}
                                            </Button>
                                        </ToolbarItem>
                                        <ToolbarSeparator/>
                                    </Fragment>
                                    {
                                        pageState.tiles.length > 0 && !pageState.isSystem &&
                                        (
                                            (pageMode == 1 && currentUser.IsAuthenticated && pageState.canCreate)  
                                            ||
                                            (pageMode == 2 && currentUser.IsAuthenticated && pageState.canEdit)
                                        )  &&
                                        <Fragment>
                                            <ToolbarItem>
                                                <Button title={saveButtonTooltip} disabled={pageState.processing} style={{color: currentTheme.primary}}   icon="save" onClick={handleOnSaveReport}>
                                                    {saveButtonTitle}
                                                </Button>
                                            </ToolbarItem>
                                            <ToolbarSeparator/>
                                        </Fragment>
                                    }
                                    {
                                        pageMode == 2 && currentUser.IsAuthenticated && pageState.canEdit && !pageState.isSystem &&
                                        <Fragment>
                                            <ToolbarItem>
                                                <DropDownButton
                                                    itemRender={schemaMenuRenderer}
                                                    popupSettings={{                                                        
                                                        popupClass: "toolbar-item-schema"
                                                    }}
                                                    disabled={pageState.processing}
                                                    text={t("reporting.design.design")}
                                                    items={designItems}
                                                    icon="template-manager"
                                                    onItemClick={(e) => {
                                                        if (e.item.id == 1)
                                                        {
                                                            //revert to default schema
                                                            handleOnRevertToDefault()
                                                        }
                                                        else if (e.item.id == 2)
                                                        {
                                                            handleOnSaveReportAsDefault()
                                                        }
                                                    }}
                                                />
                                            </ToolbarItem>
                                            <ToolbarSeparator/>
                                        </Fragment>
                                    }
                                    {
                                        pageMode == 2 && currentUser.IsAuthenticated && pageState.canCreate && pageState.canView && 
                                        <Fragment>
                                            <ToolbarItem>
                                                <Button disabled={pageState.processing || reportsMaxReached(currentUser) } title={t("reporting.design.clone_default_tooltip")} style={{color: currentTheme.primary}}   icon="backward-element" onClick={handleOnClone}>
                                                   {t("reporting.design.clonedefault")} 
                                                </Button>
                                            </ToolbarItem>
                                            <ToolbarSeparator/>
                                        </Fragment>
                                    } 
                                    {
                                        pageMode == 2 && currentUser.IsAuthenticated && !pageState.isSystem && 
                                        pageState.canDelete &&
                                        <Fragment>
                                            <ToolbarItem>
                                                <Button disabled={pageState.processing} style={{color: currentTheme.primary}}   icon="delete" onClick={handleOnDelete}>
                                                   {t("reporting.design.deleterep")}
                                                </Button>
                                            </ToolbarItem>
                                            <ToolbarSeparator/>
                                        </Fragment>
                                    } 
                                    {
                                        !pageState.isSystem &&
                                        <Fragment>
                                            <ToolbarItem>
                                                <Button disabled={pageState.processing} className="is-live-report" style={{}}  
                                                    title={`${pageState.isLiveReport ? t("reporting.design.live") : t("reporting.design.notlive")}`}  
                                                    icon={`${pageState.isLiveReport ? 'radiobutton-checked' : 'radiobutton'}`} onClick={handleOnToggleIsLiveReport}>
                                                </Button>
                                            </ToolbarItem>
                                            <ToolbarSeparator/>
                                        </Fragment>        
                                    }
                                    <Fragment>
                                        <ToolbarItem>
                                            <Button title={t("reporting.design.decrease")} disabled={pageState.processing} style={{color: currentTheme.toolbarText}}   icon={"minus"} onClick={handleOnPaperHeightDecrease}>
                                            </Button> 
                                            <div style={{display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, color: currentTheme.toolbarText}}>{t("reporting.design.height")}</div>  
                                            <Button title={t("reporting.design.decrease")} disabled={pageState.processing} style={{color: currentTheme.toolbarText}}   icon={"plus"} onClick={handleOnPaperHeightIncrease}>
                                            </Button>                                                             
                                        </ToolbarItem>
                                        <ToolbarSeparator/>
                                    </Fragment>                                                                
                                    <Fragment>
                                        <ToolbarItem>
                                            <Button disabled={pageState.processing} style={{color: currentTheme.toolbarText}}   icon={"zoom-out"} onClick={e => dispatch(zoomOut())}>
                                            </Button> 
                                            <div style={{display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, color: currentTheme.toolbarText}}>{pageState.zoom*100}%</div>  
                                            <Button disabled={pageState.processing} style={{color: currentTheme.toolbarText}}   icon={"zoom-in"} onClick={e => dispatch(zoomIn())}>
                                            </Button>                                                             
                                        </ToolbarItem>
                                        <ToolbarSeparator/>
                                    </Fragment>   
                                    {/* <Fragment>
                                        <ToolbarItem>
                                            <Button disabled={pageState.processing} className="is-favorite"  
                                                title={`${pageState.isFavorite ? "Favorite" : "Not Favorite"}`}  
                                                icon={`${pageState.isFavorite ? 'heart' : 'heart-outline' }`} onClick={handleOnToggleIsFavorite}>
                                            </Button>
                                        </ToolbarItem>
                                        <ToolbarSeparator/>
                                    </Fragment> */}
                                    <Fragment>
                                        <ToolbarItem>
                                            <Button disabled={pageState.processing} style={{color: currentTheme.primary}}   icon={"clock"} onClick={handleOnSchedule}>
                                                {t("reporting.view.schedule")}
                                            </Button>
                                        </ToolbarItem>
                                        <ToolbarSeparator/>
                                    </Fragment>
                                    <Fragment>
                                        <ToolbarItem>
                                            <Button disabled={pageState.processing} className="snapshot" style={{}}  
                                                title={t("reporting.design.snapshot")} 
                                                icon={"photo-camera"} onClick={handleOnSnapshot}>
                                            </Button>
                                        </ToolbarItem>
                                        <ToolbarSeparator/>
                                    </Fragment>  
                                    {
                                        pageMode == 2 && currentUser.IsAuthenticated && pageState.tiles.length > 0 &&
                                        (canViewAnyReport(currentUser) || canViewReport(currentUser)) &&
                                        <Fragment>
                                            <ToolbarItem>
                                                <Button disabled={pageState.processing} style={{color: currentTheme.primary}}   icon="eye" onClick={handleOnGotoViewMode}>
                                                   {t("reporting.design.view")}
                                                </Button>
                                            </ToolbarItem>
                                            <ToolbarSeparator/>
                                        </Fragment>
                                    }                           
                                </Toolbar>            
                            </div>
                            <div className="reporting-design-page-paper" ref={contentZoneRef} >
                                <div className="content" ref={contentZoneRef}>
                                    <TileLayout ref={paperContentRef}                                        
                                        columns={24}
                                        rowHeight={DEFAULT_ROW_HEIGHT}
                                        positions={pageState.tiles.map(item => item.defaultPosition)}
                                        gap={{
                                            rows: 12,
                                            columns: 12,
                                        }}
                                        items={pageState.tiles} dataItemKey={"Id"}
                                        onReposition={handleTilesReposition} 
                                    />
                                </div>
                            </div>
                        </div>
                    </Splitter>

                }
                </Fragment>
                <Fragment>
                    {                        
                        pageState.settingsFormDialogOpen &&
                        <Dialog className="widgetsettings-form-dialog" title={null}>
                            <WidgetSettingsForm pageState={pageState} formState={pageState.settingsForm}
                               onDatasetChange={handleOnSettingsFormDatasetChange} onDataSourceChange={handleOnSettingsFormDataSourceChange} 
                               onAggregateExpressionChange={handleOnSettingsFormAggregateExpressionChange}
                               onPrevious={handleOnSettingsFormPrevious} onNext={handleOnSettingsFormNext}
                               onSettingsFormFieldValueChange={handleOnSettingsFormFieldValueChange}
                               onSave={handleOnSettingsFormSave} onTickerFieldsReorder={handleOnTickerFieldsReorder}
                               onClose={handleOnCloseSettingsForm} formValidator={formValidator} t={t} />
                        </Dialog>                                
                    }
                    <style>
                        {
                            `
                            `
                        }
                    </style>
                </Fragment>
                <Fragment>
                    {                        
                        pageState.schedulePageOpen &&
                            <div onClick={handleOnWidgetSchedule(pageState.currentWidget.Id)}></div>
                            // <Dialog  className="schedule-form-dialog" title="Confirm Schedule" onClose={() => dispatch(closeSchedulePopup())}>
                            //     <p style={{ margin: "0 0 16px 0" }}>
                            //         Are you sure you want to schedule this widget?
                            //     </p>

                            //     <DialogActionsBar>
                            //         <Button onClick={() => dispatch(closeSchedulePopup())}>No</Button>
                            //         <Button themeColor="primary" onClick={() => handleOnWidgetSchedule(pageState.currentWidget.Id)}>
                            //             Yes
                            //         </Button>
                            //     </DialogActionsBar>
                            // </Dialog>                             
                    }
                </Fragment>
            </Page>
            <style>
                {
                    `
                    /*page class*/                    
                    .reporting-design-page
                    {

                    }

                    .reporting-design-page
                    {
                        padding-top: ${currentTheme.darkTheme ? "16px" : 0};
                        background-image: ${currentTheme.darkTheme ? currentTheme.appBarBgImage : "none"};
                        padding-left: ${currentTheme.darkTheme ? "12px" : 0};
                    }

                        .reporting-design-page .k-splitter .k-pane{
                      direction:${appearance.isRightToLeft ? "rtl" : "ltr"} 
                    }


                    .reporting-design-page .k-splitbar.k-splitbar-horizontal
                    {
                        background-color: ${currentTheme.paneSeparatorBg};
                    }

                    .reporting-design-page .display-none
                    {
                        display: none;
                    }

                    /*are you sure to delete*/
                    .reporting-design-page-are-you-sure .k-widget
                    {
                      /*width of the dialog*/
                      width: 300px;
                    }    
                    
                    .reporting-design-page-are-you-sure .k-widget .k-dialog-titlebar.k-header.k-header
                    {
                        /*bg color of the header*/
                        background-color: ${currentTheme.primary};
                    }

                    /*the manager*/                 
                    .reporting-design-page > .content .reporting-design-page-manager
                    {
                        border: ${currentTheme.managerBorder};
                        border-radius: ${currentTheme.pageBorderRadius};
                        background-color: ${currentTheme.componentBgFaded};

                        /*prevent selection*/
                        user-select: none;
                        -moz-user-select: none;
                        -webkit-user-select: none;
                        -ms-user-select: none;
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .k-panelbar
                    {
                      background-color: transparent;
                    }

                    .reporting-design-page > .content .reporting-design-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link
                    {
                      /*the span in the above <li> i.e. the title of every group in the manager*/  
                      background-color: transparent;
                      color: ${currentTheme.touchColor};
                      border-bottom: 1px solid ${currentTheme.separatorColor}; 
                    }

                    .reporting-design-page > .content .reporting-design-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link:hover
                    {
                      /*the above hovered - do nothing*/
                    }

                    .reporting-design-page > .content .reporting-design-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link .k-icon
                    {
                      /*the arrow near every panel header*/
                      color: ${currentTheme.touchColor}!important;
                      margin-right: 6px;
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .k-panelbar-content
                    {
                        background-color: transparent;
                    }
                    
                    .reporting-design-page > .content .reporting-design-page-manager .tools,
                    .reporting-design-page > .content .reporting-design-page-manager .report,
                    .reporting-design-page > .content .reporting-design-page-manager .k-child-animation-container
                    {
                      /*bg color of exp. manager elements */
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .k-panelbar-header
                    {
                        background-color: transparent;
                    }          

                    .reporting-design-page > .content .reporting-design-page-manager .k-panelbar-header .k-panelbar-item-text
                    {
                        /*Tools and Report Titles*/
                        margin-left: 4px;
                    }
                    
                    /*tools*/
                    .reporting-design-page > .content .reporting-design-page-manager .panel-tools
                    {
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .panel-tools .content
                    {
                        padding:16px 8px;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        flex-wrap: wrap;
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .panel-tools .content > .widget-icon .widget-icon-contour > div
                    {
                        /*tooltip div*/
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .panel-tools .content > .widget-icon .widget-icon-contour
                    {
                        padding: 4px;
                        border: 1px solid ${currentTheme.primary};
                        border-radius: 4px;
                        box-shadow: none;
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .panel-tools .content > .widget-icon > .widget-icon-contour:hover
                    {
                        cursor: pointer;
                        box-shadow: ${boxShadow};
                        background-color: ${currentTheme.darkTheme ? "transparent" : currentTheme.componentBorderColor};
                    }
                    .reporting-design-page > .content .reporting-design-page-manager .panel-tools .content > .widget-icon
                    {
                        width: 20%;/*5 icons per row*/
                        margin-bottom: 8px;
                        padding: 4px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .panel-tools .content > .widget-icon .k-svg-icon
                    {
                        /*icon of kendo*/
                        font-size:22px;
                    }

                    /*report*/
                    .reporting-design-page > .content .reporting-design-page-manager .panel-report
                    {         
                        margin-top: 0px;
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .panel-report .content
                    {                    
                        padding: 16px 10px;
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;                        
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .panel-report .content .k-input
                    {
                        /*border-color: ${currentTheme.separatorColor};*/
                        background-color: transparent;
                        color: ${currentTheme.componentText};
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .panel-report .content .k-input:focus,
                    .reporting-design-page > .content .reporting-design-page-manager .panel-report .content .k-input.k-textarea:focus-within
                    {
                        box-shadow: none !important;
                        outline: none !important;
                    }
                   
                    .reporting-design-page > .content .reporting-design-page-manager .panel-report
                    {
                        /*border-bottom: 1px solid ${currentTheme.separatorColor};*/
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .panel-report .content .panel-report-row
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;                        
                        margin-bottom: 12px;
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .panel-report .content .panel-report-row >div:nth-child(1)
                    {
                        font-size: 13px;                        
                    }
                    
                    .reporting-design-page > .content .reporting-design-page-manager .panel-report .content .panel-report-row >div:nth-child(2)
                    {
                        margin-top:2px;
                    }

                    /*security groups*/
                    reporting-design-page > .content .reporting-design-page-manager .panel-groups .content .list-container.groups
                    {
                        border: 1px solid ${currentTheme.componentBorderColor};
                        border-radius: 4px;
                        margin-top: 2px;
                        flex: 1;
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .panel-groups
                    {         
                        margin-top: 0px;
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .panel-groups .content
                    {                    
                        padding: 16px 10px;
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;                        
                    }


                    /*widget*/
                    .reporting-design-page > .content .reporting-design-page-manager .panel-widget .content
                    {
                        padding: 16px 16px;
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;                        
                    }

                    .reporting-design-page > .content .reporting-design-page-manager .panel-widget .content .panel-widget-row
                    {
                        display: flex;
                        flex-direction: row;
                        align-items: center;                        
                        justify-content: space-between;
                    }


                    /*content*/
                    .reporting-design-page .reporting-design-page-content
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        height: 100%;
                        overflow: hidden;
                        border: ${currentTheme.pageFormBorder};
                        border-radius: ${currentTheme.pageBorderRadius};
                    }
                    /*content*/

                    .reporting-design-page .k-splitbar-horizontal
                    {
                        width: 10px;
                    }

                    /*toolbar*/
                    .reporting-design-page .toolbar .k-toolbar
                    {
                      width: 100%;
                      border-left: none !important;
                      border-bottom: 1px solid ${currentTheme.separatorColor};
                      border-top: none !important;
                      border-right: none !important;
                      padding: 3px 4px 3px 0px;
                      background-color: ${currentTheme.toolbarBg};/*transparent;*/
                      direction:${appearance.isRightToLeft ? "rtl" :"ltr"}
                    }

                    .reporting-design-page .toolbar .k-toolbar
                    {
                    }

                    .reporting-design-page .toolbar .k-button
                    {
                      /*the toolbar buttons*/
                      border: none;
                      padding: 6px 8px;
                      background:transparent;
                    }

                    .reporting-design-page .toolbar .k-dropdown-button > button
                    {
                      /*the toolbar buttons*/
                      border: none;
                      padding: 6px 8px;
                      background-color: transparent;
                    }

                    .toolbar-item-schema li
                    {
                        padding: 6px !important;
                    }

                    .reporting-design-page .toolbar .k-separator 
                    {
                        border-color: ${currentTheme.primary}
                    }

                    .reporting-design-page .toolbar .k-toolbar .k-split-button:focus, .form-root .toolbar .k-toolbar .k-split-button.k-focus,
                    .reporting-design-page .toolbar .k-toolbar .k-button-solid-base:focus, .form-root .toolbar .k-toolbar .k-button-solid-base.k-focus
                    {
                        box-shadow: none !important;
                        border: none !important;
                    }

                    .reporting-design-page .toolbar .k-toolbar .k-button:active::before, .reporting-design-page .toolbar .k-toolbar .k-button:hover::before,
                    .reporting-design-page .toolbar .k-toolbar .k-button:focus::before, .reporting-design-page .toolbar .k-toolbar .k-button:focus-within::before                        
                    {
                        opacity: 0 !important;
                        border: none !important;
                        box-shadow: none !important;
                    }

                    .reporting-design-page .toolbar .k-toolbar .k-dropdown-button.k-focus .k-button::after
                    {
                        /*border: 1px solid ${currentTheme.componentBg} !important;*/
                        box-shadow: none !important;
                    }                       

                    .reporting-design-page .toolbar .k-toolbar .k-button .k-button-text
                    {
                        font-size: 13px !important;
                        font-weight: 400;
                        color: ${currentTheme.toolbarText};
                    }

                   .reporting-design-page .toolbar .k-button-icon
                    {
                      font-weight: 500;
                      color: ${currentTheme.toolbarText};
                    }

                    .reporting-design-page .toolbar .is-live-report .k-button-icon
                    {
                        padding: 2px 4px;
                        font-size: 20px;
                        /*color: ${pageState.isLiveReport ? currentTheme.success : currentTheme.disabledText}!important;*/
                    }

                    .reporting-design-page .toolbar .k-toolbar .k-button:hover .k-button-text
                    {
                        font-weight: 700;
                        font-size: 12.2px;
                    }

                    .reporting-design-page .toolbar .k-toolbar .is-favorite span
                    {
                        font-size: 18px;
                        font-weight: 700;
                    }
                    
                    /*form toolbar*/

                    /*paper*/
                    .reporting-design-page > .content  .reporting-design-page-paper
                    { 
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        flex:1;
                        overflow: auto;

                        /*prevent selection*/
                        user-select: none;
                        -moz-user-select: none;
                        -webkit-user-select: none;
                        -ms-user-select: none;
                    }

                    .reporting-design-page > .content  .reporting-design-page-paper > .content
                    {
                        transform: scale(${pageState.zoom}) translateX(0) translateY(0);  
                        transform-origin: ${zoomTransformOrigin};
                        background-image: radial-gradient(${currentTheme.separatorColor} 10%, transparent 30%);
                        background-color: ${currentTheme.componentBg};
                        background-position: 0 0, 20px 20px;
                        background-size: 6px 6px;
                        background-color: ${currentTheme.componentBg};

                        /*border: 1px solid ${currentTheme.separatorColor};*/
                        padding: 0px;
                        flex: 1; 
                        display: flex;
                        flex-direction: column;
                    }
                    
                    .reporting-design-page > .content .k-tilelayout
                    {
                        background-image: radial-gradient(${currentTheme.separatorColor} 20%, transparent 20%);
                        background-color: ${currentTheme.componentBg};
                        background-position: 0 0, 20px 20px;
                        background-size: 6px 6px;
                        background-color: ${currentTheme.componentBg};

                        /*border: 1px solid ${currentTheme.separatorColor};*/
                        padding: 0px;
                        /*flex: 1;*/
                        min-height: 100%;
                    }

                    .reporting-design-page > .content .k-tilelayout .k-tilelayout-item
                    {
                        border: none;
                    }

                    .reporting-design-page .k-tilelayout .k-card
                    {
                        border-radius: 0;
                    }
                    /*paper*/


                    /*settings form dialog*/
                    .widgetsettings-form-dialog
                    {
                        height: 100%;
                    }
                    
                    .widgetsettings-form-dialog .k-dialog
                    {                        
                        width: min(950px, calc(100vw - 32px));
                        max-width: calc(100vw - 32px);
                        height: 70%;
                        min-height: 0;
                        max-height: calc(100dvh - 32px);
                        border-radius: 8px;
                    }
                    
                    .widgetsettings-form-dialog .k-dialog-content
                    {
                        padding: 0 !important;
                        min-height: 0;
                        overflow: hidden;
                    }
                    /*settings form dialog*/


                    /*are you sure widget*/
                    .reporting-design-page-are-you-sure-widget .k-widget
                    {
                      /*width of the dialog*/
                      width: 300px;
                    }    
                    
                    .reporting-design-page-are-you-sure-widget .k-widget .k-dialog-titlebar.k-header.k-header
                    {
                        /*bg color of the header*/
                        background-color: ${currentTheme.primary};
                    }
                    /*are you sure widget*/

                    `
                }
            </style>
        </Fragment>
    );
};

//export const ReportingDesignPage = {Component: ReportingDesign};
